import {ContentContainer} from '@coolcolduk/ui-mui';
import {Button, Typography} from '@mui/material';
import {useNavigate} from 'react-router';

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <ContentContainer data-testid="error-page" center minusAppBar>
      <Typography variant="h2" component="h1" gutterBottom>
        Oops! Something went wrong
      </Typography>
      <Typography variant="body1" paragraph sx={{mb: 4}}>
        We encountered an error while loading this page. Please try again or return to the dashboard.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')} sx={{mr: 2}}>
        Go to Dashboard
      </Button>
      <Button variant="outlined" onClick={() => window.location.reload()}>
        Retry
      </Button>
    </ContentContainer>
  );
}
